var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 142C110.212 142 142 110.212 142 71C142 31.7878 110.212 0 71 0C31.7878 0 0 31.7878 0 71C0 110.212 31.7878 142 71 142Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6691 47C90.3179 47 84.4584 49.9099 78.2778 55.6496C75.3614 58.3459 72.7928 61.2825 70.9199 63.6051C70.9199 63.6051 73.9166 67.0489 77.2075 70.7597C79.0002 68.5172 81.542 65.4739 84.5119 62.7241C89.9968 57.5984 93.5821 56.5573 95.6423 56.5573C103.348 56.5573 109.609 63.0178 109.609 71C109.609 78.9021 103.348 85.3626 95.6423 85.4427C95.2677 85.4427 94.8397 85.3893 94.3045 85.2825C96.552 86.3237 98.9868 87.0712 101.261 87.0712C115.388 87.0712 118.171 77.327 118.331 76.6329C118.733 74.8443 118.973 72.9755 118.973 71.0534C118.947 57.7853 108.512 47 95.6691 47Z",
    fill: "url(#paint0_linear_2948_423)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3044 95C51.6555 95 57.5151 92.0901 63.6957 86.3504C66.6121 83.654 69.1806 80.7174 71.0535 78.3949C71.0535 78.3949 68.0569 74.951 64.7659 71.2403C62.9733 73.4827 60.4315 76.5261 57.4616 79.2758C51.9766 84.3481 48.3646 85.4427 46.3311 85.4427C38.6254 85.4427 32.3646 78.9822 32.3646 71C32.3646 63.0979 38.6254 56.6374 46.3311 56.5573C46.7057 56.5573 47.1338 56.6107 47.6689 56.7175C45.4214 55.6763 42.9866 54.9288 40.7124 54.9288C26.5853 54.9021 23.8027 64.6463 23.6421 65.3671C23.2408 67.1557 23 69.0245 23 70.9466C23 84.2147 33.4348 95 46.3044 95Z",
    fill: "url(#paint1_linear_2948_423)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0605 62.9377C55.5086 61.4427 47.9635 55.3293 40.7394 55.1157C27.8431 54.7953 24.0705 64.139 23.7227 65.3404C26.211 54.8754 35.415 47.0534 46.3314 47C55.2411 47 64.2578 55.7297 70.92 63.6051L70.9468 63.5784C70.9468 63.5784 73.9434 67.0222 77.2344 70.733C77.2344 70.733 80.9802 75.1379 84.9401 79.0089C86.4919 80.5039 94.0103 86.5373 101.234 86.7508C114.479 87.1246 118.144 77.2469 118.331 76.4994C115.897 87.0445 106.666 94.8932 95.6959 94.9466C86.7862 94.9466 77.7695 86.2169 71.0805 78.3415C71.0805 78.3682 71.0538 78.3682 71.0538 78.3949C71.0538 78.3949 68.0571 74.9511 64.7662 71.2403C64.7929 71.2403 61.0471 66.8087 57.0605 62.9377ZM23.7227 65.4472C23.7227 65.4205 23.7227 65.3938 23.7494 65.3671C23.7227 65.3938 23.7227 65.4205 23.7227 65.4472Z",
    fill: "#29ABE2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2948_423",
    x1: 83.1434,
    y1: 50.8033,
    x2: 116.054,
    y2: 84.0589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F15A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6841,
    stopColor: "#FBB03B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2948_423",
    x1: 58.8384,
    y1: 91.2021,
    x2: 25.9277,
    y2: 57.9465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8929,
    stopColor: "#522785"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcp);
export default __webpack_public_path__ + "static/media/icp.1dbbce941a4726b0e9de5dbca34e8394.svg";
export { ForwardRef as ReactComponent };